import React, { useState } from "react";
import { Dropdown } from "semantic-ui-react";
import styles from "./ResearchTeamBudgetPeriod.css";

//TODO: add dictionary
const ResearchTeamBudgetPeriod = props => {
	const { onChange, startDate, endDate, initialBudgetPeriod } = props;
	//  const dictionary = useDictionary("researchTeamBudget");
	const [ budgetPeriod, setBudgetPeriod ] = useState(() => {
		return initialBudgetPeriod || 0;
	});
	const periodOptions = Array(10).fill().map((_, index) => {
		const number = index + 1;

		return {
			text: number,
			value: number,
			key: number
		};
	});
	const internalOnChange = (e, { value }) => {
		onChange(value);
		setBudgetPeriod(value);
	};

	return (
		<div className={styles.budgetPeriodDisplay}>
			<div className={styles.toolBar}>
				<div className={styles.item}>Project Start Date: {startDate}</div>
				<div className={styles.item}> Project End Date: {endDate}</div>
				<div className={styles.item}> Budget Periods:</div>
				<div className={styles.item}>
					<Dropdown
						className={styles.zIndex}
						placeholder="# Period"
						fluid
						selection
						value={budgetPeriod}
						options={periodOptions}
						onChange={internalOnChange}
					/>
				</div>
			</div>
		</div>
	);
};
export default ResearchTeamBudgetPeriod;
